import React from "react";
import { LinkContainer } from "react-router-bootstrap";
import { NavDropdown } from "react-bootstrap";
import { FaIcon } from "../../../lib/FaIcon";

export const Link = ({ to, icon, label, className = "", active, onClick }) => (
  <LinkContainer to={to} onClick={onClick}>
    <NavDropdown.Item href="#" aria-label="Search button" className={className + (active ? " active" : "")}>
      <FaIcon icon={icon} className="ml-0 mr-3 mr-md-3"></FaIcon>
      {label}
    </NavDropdown.Item>
  </LinkContainer>
);
